import React from "react";

export default function IconFeedback() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 27 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.833 0.083252H3.16634C1.74551 0.083252 0.595924 1.24575 0.595924 2.66659L0.583008 25.9166L5.74967 20.7499H23.833C25.2538 20.7499 26.4163 19.5874 26.4163 18.1666V2.66659C26.4163 1.24575 25.2538 0.083252 23.833 0.083252ZM5.74967 15.5833V12.3928L14.6363 3.50617C14.8947 3.24784 15.2951 3.24784 15.5534 3.50617L17.8397 5.79242C18.098 6.05075 18.098 6.45117 17.8397 6.7095L8.94009 15.5833H5.74967ZM21.2497 15.5833H11.5622L14.1455 12.9999H21.2497V15.5833Z" />
    </svg>
  );
}
